export default __webpack_public_path__ + "static/media/Document_Grey_Large.81c66bab.svg";